import { createRoute } from '@tanstack/react-router';

import { NotFoundPage } from '$/pages/NotFoundPage';
import { RootRoute } from '$/routes/RootRoute';

export const NotFoundRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/not-found',
  component: NotFoundPage,
});
